import { memo, useMemo } from 'react';
import { CUSTOM_NODE } from '../const';
import type { Node, NodeProps } from '../types';
import NodeWrapper from './_base/node-wrapper';
import PanelWrapper from './_base/panel-wrapper';
import { NodeComponentMap, PanelComponentMap } from './constants';

export const CustomNode = memo((props: NodeProps) => {
  const nodeData = props.data;
  const NodeComponent = NodeComponentMap[nodeData.type];

  return (
    <>
      <NodeWrapper {...props}>
        <NodeComponent />
      </NodeWrapper>
    </>
  );
});
CustomNode.displayName = 'CustomNode';

export const Panel: React.FC<{ node: Node }> = memo(
  ({ node }) => {
    const nodeType = node.type;
    const nodeData = node.data;

    const PanelComponent = useMemo(() => {
      if (nodeType === CUSTOM_NODE) return PanelComponentMap?.[nodeData.type];
      return undefined;
    }, [nodeType, nodeData.type]);

    const shouldShowPanel = useMemo(() => {
      return nodeType === CUSTOM_NODE && PanelComponent !== undefined;
    }, [nodeType, PanelComponent]);

    if (shouldShowPanel && PanelComponent) {
      return (
        <PanelWrapper key={node.id} {...node}>
          <PanelComponent />
        </PanelWrapper>
      );
    }

    return null;
  },
  (prev, cur) => {
    return prev.node.id === cur.node.id;
  },
);

Panel.displayName = 'Panel';

export * from './constants';
